// extracted by mini-css-extract-plugin
module.exports = {"button":"SimpleButton_button__262Zv","gray":"SimpleButton_gray__WdDrs","black":"SimpleButton_black__26W7w"};